import { Select } from '@mui/material';

const AddressSelect = ({ id, name, value, onChange, error, children, ...props }) => {
  return (
    <Select
      displayEmpty
      fullWidth
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      sx={{
        height: '45px',
        borderRadius: '8px',
        backgroundColor: '#F5F5F5',
        outline: error ? '1px solid #ED1C24' : 'none',
        fontSize: '1.25rem',

        '& .MuiSelect-select': {
          padding: '0 10px',
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#F5F5F5',
        },
      }}
      {...props}
    >
      {children}
    </Select>
  );
};
export default AddressSelect;
